import { BentoColumnWidgetDefinition } from './BentoWidgets/BentoColumnWidget'
import { BentoRowWidgetDefinition } from './BentoWidgets/BentoRowWidget'
import { BrowserTitleReporterDefinition } from './BrowserTitleReporter/BrowserTitleReporter'
import { CardHeaderContainerWidgetDefinition } from './CardHeaderContainer/CardHeaderContainer'
import { CardWidgetDefinition } from './CardWidget/CardWidget'
import { ChartWidgetDefinition } from './ChartWidget/ChartWidget'
import { CollapsableSectionWidgetDefinition } from './CollapsableSectionWidget/CollapsableSectionWidget'
import { ConditionalWidgetDefinition } from './ConditionalWidget/ConditionalWidget'
import { DashboardPageHeaderContainerWidgetDefinition } from './DashboardPageHeaderContainerWidget/DashboardPageHeaderContainerWidget'
import { DashboardWidgetDefinition } from './DashboardWidget/DashboardWidget'
import { DeltaTrendWidgetDefinition } from './DeltaTrendWidget/DeltaTrendWidget'
import { DetailWidgetDefinition } from './DetailWidget/DetailWidget'
import { DialWidgetDefinition } from './DialWidget/DialWidget'
import { DrawerCardWidgetDefinition } from './DrawerCardWidget/DrawerCardWidget'
import { ExpandableCardWidgetDefinition } from './ExpandableCardWidget/ExpandableCardWidget'
import { FilterEditorWidgetDefinition } from './FilterEditor/FilterEditorWidget'
import { FlexBoxWidgetDefinition } from './FlexBoxWidget/FlexBoxWidget'
import { HeaderBackLinkWidgetDefinition } from './HeaderBackLinkWidget/HeaderBackLinkWidget'
import { HeadingWidgetDefinition } from './HeadingWidget/HeadingWidget'
import { IconWidgetDefinition } from './IconWidget/IconWidget'
import { LinkWidgetDefinition } from './LinkWidget/LinkWidget'
import { MilestoneWidgetDefinition } from './MilestoneWidget/MilestoneWidget'
import { ModeIconWidgetDefinition } from './ModeIconWidget/ModeIconWidget'
import { OverlayWidgetDefinition } from './OverlayWidget/OverlayWidget'
import { PageHeaderContainerWidgetDefinition } from './PageHeaderContainerWidget/PageHeaderContainerWidget'
import { PageHeaderTagsRowWidgetDefinition } from './PageHeaderTagsRowWidget/PageHeaderTagsRowWidget'
import { PageLayoutWidgetDefinition } from './PageLayoutWidget/PageLayoutWidget'
import { PillWidgetDefinition } from './PillWidget/PillWidget'
import { RelatedShipmentsWidgetDefinition } from './RelatedShipmentsWidget/RelatedShipmentsWidget'
import { RepeaterWidgetDefinition } from './RepeaterWidget/RepeaterWidget'
import { RowWidgetDefinition } from './RowWidget/RowWidget'
import { SavedViewNameWidgetDefinition } from './SavedViewNameWidget/SavedViewNameWidget'
import { ServiceProviderLinkWidgetDefinition } from './ServiceProviderLinkWidget/ServiceProviderLinkWidget'
import { StackWidgetDefinition } from './StackWidget/StackWidget'
import { TabGroupWidgetDefinition } from './TabGroupWidget/TabGroupWidget'
import { TabWidgetDefinition } from './TabWidget/TabWidget'
import { TableWidgetDefinition } from './TableWidget/TableWidget'
import { TagListWidgetDefinition } from './TagList/TagList'
import { TextWidgetDefinition } from './TextWidget/TextWidget'
import { TooltipWidgetDefinition } from './Tooltip/TooltipWidget'

export const widgetRegistry = {
  [BrowserTitleReporterDefinition.type]: BrowserTitleReporterDefinition,
  [BentoColumnWidgetDefinition.type]: BentoColumnWidgetDefinition,
  [BentoRowWidgetDefinition.type]: BentoRowWidgetDefinition,
  [CardHeaderContainerWidgetDefinition.type]:
    CardHeaderContainerWidgetDefinition,
  [CardWidgetDefinition.type]: CardWidgetDefinition,
  [CollapsableSectionWidgetDefinition.type]: CollapsableSectionWidgetDefinition,
  [DashboardWidgetDefinition.type]: DashboardWidgetDefinition,
  [ChartWidgetDefinition.type]: ChartWidgetDefinition,
  [ConditionalWidgetDefinition.type]: ConditionalWidgetDefinition,
  [DashboardPageHeaderContainerWidgetDefinition.type]:
    DashboardPageHeaderContainerWidgetDefinition,
  [DeltaTrendWidgetDefinition.type]: DeltaTrendWidgetDefinition,
  [DetailWidgetDefinition.type]: DetailWidgetDefinition,
  [DialWidgetDefinition.type]: DialWidgetDefinition,
  [DrawerCardWidgetDefinition.type]: DrawerCardWidgetDefinition,
  [ExpandableCardWidgetDefinition.type]: ExpandableCardWidgetDefinition,
  [FilterEditorWidgetDefinition.type]: FilterEditorWidgetDefinition,
  [FlexBoxWidgetDefinition.type]: FlexBoxWidgetDefinition,
  [HeaderBackLinkWidgetDefinition.type]: HeaderBackLinkWidgetDefinition,
  [HeadingWidgetDefinition.type]: HeadingWidgetDefinition,
  [IconWidgetDefinition.type]: IconWidgetDefinition,
  [LinkWidgetDefinition.type]: LinkWidgetDefinition,
  [MilestoneWidgetDefinition.type]: MilestoneWidgetDefinition,
  [ModeIconWidgetDefinition.type]: ModeIconWidgetDefinition,
  [OverlayWidgetDefinition.type]: OverlayWidgetDefinition,
  [PageHeaderContainerWidgetDefinition.type]:
    PageHeaderContainerWidgetDefinition,
  [PageHeaderTagsRowWidgetDefinition.type]: PageHeaderTagsRowWidgetDefinition,
  [PageLayoutWidgetDefinition.type]: PageLayoutWidgetDefinition,
  [PillWidgetDefinition.type]: PillWidgetDefinition,
  [RelatedShipmentsWidgetDefinition.type]: RelatedShipmentsWidgetDefinition,
  [RepeaterWidgetDefinition.type]: RepeaterWidgetDefinition,
  [RowWidgetDefinition.type]: RowWidgetDefinition,
  [SavedViewNameWidgetDefinition.type]: SavedViewNameWidgetDefinition,
  [ServiceProviderLinkWidgetDefinition.type]:
    ServiceProviderLinkWidgetDefinition,
  [StackWidgetDefinition.type]: StackWidgetDefinition,
  [TabWidgetDefinition.type]: TabWidgetDefinition,
  [TabGroupWidgetDefinition.type]: TabGroupWidgetDefinition,
  [TableWidgetDefinition.type]: TableWidgetDefinition,
  [TagListWidgetDefinition.type]: TagListWidgetDefinition,
  [TextWidgetDefinition.type]: TextWidgetDefinition,
  [TooltipWidgetDefinition.type]: TooltipWidgetDefinition,
}

export type WidgetRegistry = typeof widgetRegistry
